import { useParams, Link } from "react-router-dom";
import { COMPANY, SERVICE_AREAS } from "@/lib/api";
import { Phone, CalendarClock, FileText, MapPin } from "lucide-react";
import FAQ from "@/components/site/FAQ";
import { onCallClick } from "@/lib/dialer";

export default function CityPage() {
  const { city: slug } = useParams();
  const allCities = Object.values(SERVICE_AREAS).flat();
  const cityName = allCities.find(c => c.toLowerCase().replace(/ /g,"-") === slug?.toLowerCase()) || decodeURIComponent(slug||"").replace(/-/g," ").replace(/\b\w/g,m=>m.toUpperCase());
  return (
    <main data-testid="city-page">
      <section className="section-pad bg-ink-800/30">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <div className="text-xs uppercase tracking-[0.22em] text-ice-400 flex items-center gap-2"><MapPin className="size-3.5"/> Service Area</div>
          <h1 className="mt-3 font-display text-4xl md:text-6xl font-black">HVAC Services in {cityName}, CA</h1>
          <p className="mt-4 text-silver-300 max-w-2xl">
            AIR-COLD HVAC provides professional HVAC repair, installation, maintenance, and replacement services in {cityName}. Our technicians help homeowners and businesses with reliable solutions, fast service, and free estimates.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="btn-primary rounded-full px-5 py-3 text-sm flex items-center gap-2" data-testid="city-call"><Phone className="size-4"/> {COMPANY.phone}</a>
            <Link to="/schedule" className="btn-ghost rounded-full px-5 py-3 text-sm flex items-center gap-2" data-testid="city-schedule"><CalendarClock className="size-4"/> Schedule</Link>
            <Link to="/#estimate" className="btn-ghost rounded-full px-5 py-3 text-sm flex items-center gap-2" data-testid="city-estimate"><FileText className="size-4"/> Free Estimate</Link>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="mx-auto max-w-6xl px-5 md:px-8 grid md:grid-cols-3 gap-6">
          <Card title={`HVAC Services in ${cityName}`} body="AC repair, AC installation, furnace service, heat pumps, mini splits, ducts, and indoor air quality — residential and light commercial."/>
          <Card title="Local Climate" body={`Southern California summers can be brutal. We size systems for ${cityName} homes specifically — not from a chart, from experience.`}/>
          <Card title="Brands We Service" body="Carrier, Lennox, Trane, Goodman, Mitsubishi, LG, Midea, Fuji, and every other major brand. Repair or replace — your choice."/>
        </div>
      </section>
      <FAQ/>
    </main>
  );
}

function Card({ title, body }) {
  return (
    <div className="card-ink rounded-2xl p-6">
      <h3 className="font-display text-lg font-bold">{title}</h3>
      <p className="mt-2 text-silver-300 text-sm">{body}</p>
    </div>
  );
}
